
// this must be empty
export let assets = {};